module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/DiamondSolid.8cb1af9d.svg";